<template>
    <div class="container-fluid g-2 web5__rowcard">
      <div class="row align-items-start pb-2 pt-2">  
        <div class="col-1">        
          <button type="button" @click.prevent="onButtonRefresh" class="btn btn-outline-primary same__size">Anzeigen</button>
        </div>
        <div class="col-1">        
         </div>
         <div class="col-2">        
          <button type="button" @click.prevent="onExecRechnungNord" class="btn btn-outline-primary same__size">Nord berechnen</button>
        </div>
        <div class="col-1">        
        </div>
        <div class="col-2">        
          <button type="button" @click.prevent="onExecRechnungSued" class="btn btn-outline-primary same__size">Sued berechnen</button>
        </div>
        <div class="col-1">        
        </div>
      </div>

     
      <div class="row align-items-start pb-2">
        <div clas="col-12">
          <Grid
            ref="grid"
            :style="{ height: '900px' }"
            :selected-field="selectedField"
            :data-items="filteredData"
            :columns="columns"
            :filterable="true"
            :filter="filter"
            :sortable="true"
            :sort="sort"
            @selectionchange="onSelectionChange"
            @headerselectionchange="onHeaderSelectionChange"
            @filterchange="filterChange"
            @sortchange="sortChange"
            :filter-cell-render="filterRender"
          >
            <template v-slot:filterSlotTemplate="{ props }">
              <div>
                <input
                  type="text"
                  :value="props.value"
                  @input="
                    (ev) => {
                      props.onChange({
                        operator: 'contains',
                        field: props.field,
                        value: ev.target.value,
                        syntheticEvent: ev,
                      });
                    }
                  "
                  style="width: 120px"
                />
                <button
                  @click="
                    (ev) => {
                      props.onChange({
                        operator: '',
                        field: '',
                        value: '',
                        event: ev,
                      });
                    }
                  "
                >
                  Clear
                </button>
              </div>
            </template>
          </grid>
        </div>
     </div>
   
    <div v-if="spinner" class ="spinner__centered">
      <img src="img/icon/icons8-spinner.gif" alt="Bitte warten ..." />
    </div>
  </div>
</template>

<script>

import { Grid } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import { UserProfile } from "@/infrastructure/backend/userProfile";

export default {
  name: "ShowDeviceData",
  inheritAttrs: false,
  components: {
    Grid
  },
  data: function () {
    return {
      currentSelectedItem: undefined,
      selectCount: 0,
      selectedBereich: "",
      spinner: false,
      selected: {},
      filter: {},
      sort: [
      ],
      selectedField: "selected",
      filteredData: [],
      originData: [],
      staticColumns: [ 
        { field: 'fkMandant', title: 'fkMandant', width:'100px',  filterable: false, hidden: true },
        { field: 'nameBereich', title: 'Bereich', filterCell: 'filterSlotTemplate', width:'280px' },        
        { field: 'totalInklMwst', title: 'TotalInklMWST', filterable: false, width:'180px' },
        { field: 'rechTotalAktuellOhneMwst', title: 'RechTotalAktuellOhneMWST', filterable: false, width:'180px' },
        { field: 'bezahlungErfolgt', title: 'Bezahlt am', filterCell: 'filterSlotTemplate', width:'180px' }
      ],
    };
  },
  computed: {
    areAllSelected() {
      try {
        if (this.filteredData.length == 0) {
          return false;
        }
        return this.filteredData.findIndex((item) => item.selected === false) === -1        
      } catch (e) {
        console.log(e);
      }
      return false;
    },
    columns() {
      return [
        {
          field: "selected",
          width: "50px",
          filterable: false,
          headerSelectionValue: this.areAllSelected,
        },
        ...this.staticColumns,
      ];
    },
  },
  methods: {
    onButtonRefresh() {
      this.getData();
    },
    onExecRechnungSued() {
      this.rechnungSued()
    },
    onExecRechnungNord() {
      this.rechnungNord()
    },
    async rechnungSued() {
      this.spinner = true;
      try {
        const temp = await apiPost("ComponentView/erzeugeRechnungenSued", {userId: UserProfile.GetUserProfile().exposedUserId});
      } catch(e) {
        console.log(e)
      }
      this.spinner = false;
    },
    async rechnungNord() {
      this.spinner = true;
      try {
        const temp = await apiPost("ComponentView/erzeugeRechnungenNord", {userId: UserProfile.GetUserProfile().exposedUserId});
      } catch(e) {
        console.log(e)
      }
      this.spinner = false;
    },

    onHeaderSelectionChange(event) {
      this.selectCount = 0;
      this.selectedBereich = "";
      let checked = event.event.target.checked;      
      this.filteredData = this.filteredData.map((item) => {
        return { ...item, selected: checked };
      });
      this.selected.records = []
      let i = 0;
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          this.selected.records.push(item);
          i = i + 1;
        }
      });
      this.selectCount = i;
      if (i == 1) {
         this.selectedBereich = this.selected.records[0].nameBereich;
      }
      else {
        this.selectedBereich ="";
      }

    },
    onSelectionChange(event) {
      this.selectionChanged(event);
    },

    selectionChanged( event ) {
      this.selectCount = 0;
      this.selectedBereich = "";
      if ( event.dataItem[this.selectedField] !== undefined) {
        event.dataItem[this.selectedField] = !event.dataItem[this.selectedField];
      }
      else {
        event.dataItem[this.selectedField] = true;
      }

      if (this.selected === undefined) {
        this.selected.records = [];
      }

      if (this.selected.records === undefined) {
        this.selected.records = [];
      }

      let i = 0;
      this.selected.records = [];
      this.filteredData.forEach((item) => {
        if (item.selected === true) {
          this.selected.records.push(item);
          i = i + 1;
        }
      });
      this.selectCount = i;
      if (i == 1) {
         this.selectedBereich = this.selected.records[0].nameBereich;
      }
      else {
        this.selectedBereich ="";
      }
    },
   
    filterChange: function (ev) {
      this.selectCount = 0;
      this.selectedBereich = "";
      this.filter = ev.filter;
      this.filteredData = filterBy(this.originData, this.filter);
    },
    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },
    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.filteredData, this.sort);
    },
    async getData() {
      this.selectCount = 0;
       this.selectedBereich = "";
      this.spinner = true;
      const temp = await apiPost("ComponentView/getBezahlungsInformationen", {userId: UserProfile.GetUserProfile().exposedUserId});
      this.filteredData = temp.map((item) => {
        return { ...item };
      });
      this.originData = temp.map((item) => {
        return { ...item };
      });

      try {
        this.filteredData = filterBy(this.originData, this.filter);
         this.filteredData = orderBy(this.filteredData, this.sort);
      } 
      catch( e ) {
        console.log(e);
      }

      this.spinner = false;
    },
  }
}
</script>
<style scoped language="scss">
.spinner__centered {
  position: fixed;
  left: 460px;
  top: 400px;
  z-index: 999;
}

.k-grid {
  font-size: 12px !important;
}
.select__max {
  max-width: 120px;
  min-width: 120px;
}

.select__max-mandant
{
  margin-left: 2px;
  max-width: 340px;
  min-width: 340px;
}

.label__adjust {
  margin-top: 5px;
}

.form-switch {
    border-radius: 2em;
    height: 25px;
    width: 25px;
}

.checkbox__adjust{
  margin-top: 3px;
}

.left_offset{
  margin-left: 14px;
}

.same__size {
  min-width: 105px;
  padding-left: 5px;
  padding-right: 5px;
}

</style>